"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ignoreErrors = void 0;
/* eslint-disable prefer-rest-params */
const toIgnore = [
    'Check the render method of `PickersCalendar`',
    'You have provided a `view` prop to `Calendar`',
    'You have provided a `date` prop to `Calendar`',
    'disableUnderline',
];
const _cnsole = console;
const _argsContainIgnoreStrings = (args) => {
    for (const a of args) {
        const result = toIgnore.some(ig => {
            if (Array.isArray(a))
                return _argsContainIgnoreStrings(a);
            else if (typeof a === 'string')
                return a.indexOf(ig) >= 0;
        });
        if (result)
            return true;
    }
};
function ignoreErrors() {
    let _warn = _cnsole.warn;
    let _error = _cnsole.error;
    _cnsole.error = function () {
        let ignore = _argsContainIgnoreStrings(arguments);
        if (!ignore)
            _error.apply(console, arguments);
    };
    _cnsole.warn = function () {
        let ignore = _argsContainIgnoreStrings(arguments);
        if (!ignore)
            _warn.apply(console, arguments);
    };
}
exports.ignoreErrors = ignoreErrors;
exports.default = ignoreErrors;
